<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0"></h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="card" style="width: 100%;">
                <!--MENU SUPERIOR-->
            </div>

            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span> </span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->

            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">
                <div aling="center">
                    <img src="./assets/images/norm35/Mesa de trabajo 12.png" alt="Logo-Norm35" class="centradoIMG ">
                </div><br>

                <div *ngFor="let datita of data">
                    <p *ngIf="dataId.id == datita.id">{{datita.tittle}}</p>
                    <p *ngIf="dataId.id == datita.id">{{datita.info}}</p>

                </div><br>

                <table class="customTable" style="width: 100%;">
                    <tbody tbody *ngFor="let datita of data">
                        <tr *ngFor="let step of datita.steps" style="width: 100%;">
                            <td *ngIf="dataId.id == datita.id" style="width:70%;  ">
                                {{step.descripcion}}
                            </td>
                            <td *ngIf="dataId.id == datita.id" style="width:30%;">{{step.status}}
                            </td>
                        </tr>

                    </tbody>
                </table>

            </div>
        </div>

        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

</div>
<!-- / CENTER -->
